import { Cloudinary } from "@cloudinary/base";
import { fill, pad } from "@cloudinary/base/actions/resize";
import { format } from "@cloudinary/base/actions/delivery";
import byRadius from "@cloudinary/base/actions/roundCorners/byRadius";

const CLOUD_NAME = process.env.VUE_APP_CLOUDINARY_CLOUD_NAME || "theos-fi";
// Docs on how to format image using Cloudinary:
// https://cloudinary.com/documentation/sdks/js/cloudinary-js-base/Actions.Delivery.html#.format
// https://cloudinary.com/documentation/resizing_and_cropping
// https://cloudinary.com/documentation/javascript2_quick_start
// https://cloudinary.com/documentation/javascript2_image_transformations
const imageStyles = {
  original: function (image) {
    return image;
  },
  "user.avatar": function (image) {
    return image.resize(fill().height(400).width(400));
  },
  "user.profile": function (image) {
    return image.resize(fill().height(400).width(400));
  },
  "nft.background": function (image) {
    return image.delivery(format("png"));
  },
  "nft.show.image": function (image) {
    return image
      .delivery(format("auto"))
      .resize(fill().height(500))
      .roundCorners(byRadius(14));
  },
  "nft.show.audio": function (image) {
    return image
      .delivery(format("auto"))
      .resize(fill().height(1000).width(1000))
      .roundCorners(byRadius(14));
  },
  "nft.list": function (image) {
    return image
      .delivery(format("auto"))
      .resize(pad().height(700).width(700))
      .backgroundColor("transparent");
  },
};

class ImageTransformer {
  constructor(styleObject, cloudName) {
    this.styleObject = styleObject;
    this.cloudinary = new Cloudinary({ cloud: { cloudName: cloudName } });
  }

  transform(filename, style) {
    return this.styleObject[style](this.cloudinary.image(filename)).toURL();
  }
}

const cloudinaryInstance = new ImageTransformer(imageStyles, CLOUD_NAME);
export default cloudinaryInstance;
